import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { HouseholdPermissionService } from '@se-po/shared-data-access-services'
import { loadSeFeTheme } from 'se-fe-themes'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import {
  CentralServiceResources as cs
} from 'se-resource-types'

@Component({
  selector: 'se-po-persona-picker',
  templateUrl: './persona-picker.component.html',
  styleUrls: ['./persona-picker.component.scss'],
})
export class PersonaPickerComponent implements OnInit {
  @Output() public pick = new EventEmitter<cs.Households.UserProfile>()
  @Output() public edit = new EventEmitter<cs.Households.UserProfile>()

  public selfProfile: cs.Households.UserProfile
  public managedProfiles: cs.Households.UserProfile[]
  public permissions: HouseholdPermissionService
  public ready = false

  constructor(
    private el: ElementRef,
    private seFeTranslationsLoader: SeFeTranslationsLoader
  ) {
    loadSeFeTheme({
      shadowRoot: this.el.nativeElement.shadowRoot,
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com',
    })
  }

  @Input() public set profiles(profiles: cs.Households.UserProfile[]) {
    this.updateProfiles(profiles)
  }

  public ngOnInit(): void {
    this.initTranslations()
  }

  public onPick(e: any): void {
    this.pick.emit(e)
  }

  public onEdit(e: any): void {
    this.edit.emit(e)
  }

  private initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-persona-picker/assets/translations').then(() => {
      this.ready = true
    })
  }

  private updateProfiles(profiles: cs.Households.UserProfile[]): void {
    this.permissions = HouseholdPermissionService.forProfiles(profiles)
    this.selfProfile = this.permissions.selfProfile
    this.managedProfiles = this.permissions.managedOtherProfiles
  }
}
